function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from './Location';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import Dimension from './Dimension';
import Cloneable from '../../../../java/lang/Cloneable';
import StringBuilder from '../../../../java/lang/StringBuilder';
var IntersectionMatrix = /*#__PURE__*/function () {
  function IntersectionMatrix() {
    _classCallCheck(this, IntersectionMatrix);
    IntersectionMatrix.constructor_.apply(this, arguments);
  }
  return _createClass(IntersectionMatrix, [{
    key: "isIntersects",
    value: function isIntersects() {
      return !this.isDisjoint();
    }
  }, {
    key: "isCovers",
    value: function isCovers() {
      var hasPointInCommon = IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.BOUNDARY]) || IntersectionMatrix.isTrue(this._matrix[Location.BOUNDARY][Location.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[Location.BOUNDARY][Location.BOUNDARY]);
      return hasPointInCommon && this._matrix[Location.EXTERIOR][Location.INTERIOR] === Dimension.FALSE && this._matrix[Location.EXTERIOR][Location.BOUNDARY] === Dimension.FALSE;
    }
  }, {
    key: "isCoveredBy",
    value: function isCoveredBy() {
      var hasPointInCommon = IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.BOUNDARY]) || IntersectionMatrix.isTrue(this._matrix[Location.BOUNDARY][Location.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[Location.BOUNDARY][Location.BOUNDARY]);
      return hasPointInCommon && this._matrix[Location.INTERIOR][Location.EXTERIOR] === Dimension.FALSE && this._matrix[Location.BOUNDARY][Location.EXTERIOR] === Dimension.FALSE;
    }
  }, {
    key: "set",
    value: function set() {
      if (arguments.length === 1) {
        var dimensionSymbols = arguments[0];
        for (var i = 0; i < dimensionSymbols.length; i++) {
          var row = Math.trunc(i / 3);
          var col = i % 3;
          this._matrix[row][col] = Dimension.toDimensionValue(dimensionSymbols.charAt(i));
        }
      } else if (arguments.length === 3) {
        var _row = arguments[0];
        var column = arguments[1];
        var dimensionValue = arguments[2];
        this._matrix[_row][column] = dimensionValue;
      }
    }
  }, {
    key: "isContains",
    value: function isContains() {
      return IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.INTERIOR]) && this._matrix[Location.EXTERIOR][Location.INTERIOR] === Dimension.FALSE && this._matrix[Location.EXTERIOR][Location.BOUNDARY] === Dimension.FALSE;
    }
  }, {
    key: "setAtLeast",
    value: function setAtLeast() {
      if (arguments.length === 1) {
        var minimumDimensionSymbols = arguments[0];
        for (var i = 0; i < minimumDimensionSymbols.length; i++) {
          var row = Math.trunc(i / 3);
          var col = i % 3;
          this.setAtLeast(row, col, Dimension.toDimensionValue(minimumDimensionSymbols.charAt(i)));
        }
      } else if (arguments.length === 3) {
        var _row2 = arguments[0];
        var column = arguments[1];
        var minimumDimensionValue = arguments[2];
        if (this._matrix[_row2][column] < minimumDimensionValue) {
          this._matrix[_row2][column] = minimumDimensionValue;
        }
      }
    }
  }, {
    key: "setAtLeastIfValid",
    value: function setAtLeastIfValid(row, column, minimumDimensionValue) {
      if (row >= 0 && column >= 0) {
        this.setAtLeast(row, column, minimumDimensionValue);
      }
    }
  }, {
    key: "isWithin",
    value: function isWithin() {
      return IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.INTERIOR]) && this._matrix[Location.INTERIOR][Location.EXTERIOR] === Dimension.FALSE && this._matrix[Location.BOUNDARY][Location.EXTERIOR] === Dimension.FALSE;
    }
  }, {
    key: "isTouches",
    value: function isTouches(dimensionOfGeometryA, dimensionOfGeometryB) {
      if (dimensionOfGeometryA > dimensionOfGeometryB) {
        return this.isTouches(dimensionOfGeometryB, dimensionOfGeometryA);
      }
      if (dimensionOfGeometryA === Dimension.A && dimensionOfGeometryB === Dimension.A || dimensionOfGeometryA === Dimension.L && dimensionOfGeometryB === Dimension.L || dimensionOfGeometryA === Dimension.L && dimensionOfGeometryB === Dimension.A || dimensionOfGeometryA === Dimension.P && dimensionOfGeometryB === Dimension.A || dimensionOfGeometryA === Dimension.P && dimensionOfGeometryB === Dimension.L) {
        return this._matrix[Location.INTERIOR][Location.INTERIOR] === Dimension.FALSE && (IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.BOUNDARY]) || IntersectionMatrix.isTrue(this._matrix[Location.BOUNDARY][Location.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[Location.BOUNDARY][Location.BOUNDARY]));
      }
      return false;
    }
  }, {
    key: "isOverlaps",
    value: function isOverlaps(dimensionOfGeometryA, dimensionOfGeometryB) {
      if (dimensionOfGeometryA === Dimension.P && dimensionOfGeometryB === Dimension.P || dimensionOfGeometryA === Dimension.A && dimensionOfGeometryB === Dimension.A) {
        return IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.INTERIOR]) && IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.EXTERIOR]) && IntersectionMatrix.isTrue(this._matrix[Location.EXTERIOR][Location.INTERIOR]);
      }
      if (dimensionOfGeometryA === Dimension.L && dimensionOfGeometryB === Dimension.L) {
        return this._matrix[Location.INTERIOR][Location.INTERIOR] === 1 && IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.EXTERIOR]) && IntersectionMatrix.isTrue(this._matrix[Location.EXTERIOR][Location.INTERIOR]);
      }
      return false;
    }
  }, {
    key: "isEquals",
    value: function isEquals(dimensionOfGeometryA, dimensionOfGeometryB) {
      if (dimensionOfGeometryA !== dimensionOfGeometryB) {
        return false;
      }
      return IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.INTERIOR]) && this._matrix[Location.INTERIOR][Location.EXTERIOR] === Dimension.FALSE && this._matrix[Location.BOUNDARY][Location.EXTERIOR] === Dimension.FALSE && this._matrix[Location.EXTERIOR][Location.INTERIOR] === Dimension.FALSE && this._matrix[Location.EXTERIOR][Location.BOUNDARY] === Dimension.FALSE;
    }
  }, {
    key: "toString",
    value: function toString() {
      var builder = new StringBuilder('123456789');
      for (var ai = 0; ai < 3; ai++) {
        for (var bi = 0; bi < 3; bi++) {
          builder.setCharAt(3 * ai + bi, Dimension.toDimensionSymbol(this._matrix[ai][bi]));
        }
      }
      return builder.toString();
    }
  }, {
    key: "setAll",
    value: function setAll(dimensionValue) {
      for (var ai = 0; ai < 3; ai++) {
        for (var bi = 0; bi < 3; bi++) {
          this._matrix[ai][bi] = dimensionValue;
        }
      }
    }
  }, {
    key: "get",
    value: function get(row, column) {
      return this._matrix[row][column];
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var temp = this._matrix[1][0];
      this._matrix[1][0] = this._matrix[0][1];
      this._matrix[0][1] = temp;
      temp = this._matrix[2][0];
      this._matrix[2][0] = this._matrix[0][2];
      this._matrix[0][2] = temp;
      temp = this._matrix[2][1];
      this._matrix[2][1] = this._matrix[1][2];
      this._matrix[1][2] = temp;
      return this;
    }
  }, {
    key: "matches",
    value: function matches(requiredDimensionSymbols) {
      if (requiredDimensionSymbols.length !== 9) {
        throw new IllegalArgumentException('Should be length 9: ' + requiredDimensionSymbols);
      }
      for (var ai = 0; ai < 3; ai++) {
        for (var bi = 0; bi < 3; bi++) {
          if (!IntersectionMatrix.matches(this._matrix[ai][bi], requiredDimensionSymbols.charAt(3 * ai + bi))) {
            return false;
          }
        }
      }
      return true;
    }
  }, {
    key: "add",
    value: function add(im) {
      for (var i = 0; i < 3; i++) {
        for (var j = 0; j < 3; j++) {
          this.setAtLeast(i, j, im.get(i, j));
        }
      }
    }
  }, {
    key: "isDisjoint",
    value: function isDisjoint() {
      return this._matrix[Location.INTERIOR][Location.INTERIOR] === Dimension.FALSE && this._matrix[Location.INTERIOR][Location.BOUNDARY] === Dimension.FALSE && this._matrix[Location.BOUNDARY][Location.INTERIOR] === Dimension.FALSE && this._matrix[Location.BOUNDARY][Location.BOUNDARY] === Dimension.FALSE;
    }
  }, {
    key: "isCrosses",
    value: function isCrosses(dimensionOfGeometryA, dimensionOfGeometryB) {
      if (dimensionOfGeometryA === Dimension.P && dimensionOfGeometryB === Dimension.L || dimensionOfGeometryA === Dimension.P && dimensionOfGeometryB === Dimension.A || dimensionOfGeometryA === Dimension.L && dimensionOfGeometryB === Dimension.A) {
        return IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.INTERIOR]) && IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.EXTERIOR]);
      }
      if (dimensionOfGeometryA === Dimension.L && dimensionOfGeometryB === Dimension.P || dimensionOfGeometryA === Dimension.A && dimensionOfGeometryB === Dimension.P || dimensionOfGeometryA === Dimension.A && dimensionOfGeometryB === Dimension.L) {
        return IntersectionMatrix.isTrue(this._matrix[Location.INTERIOR][Location.INTERIOR]) && IntersectionMatrix.isTrue(this._matrix[Location.EXTERIOR][Location.INTERIOR]);
      }
      if (dimensionOfGeometryA === Dimension.L && dimensionOfGeometryB === Dimension.L) {
        return this._matrix[Location.INTERIOR][Location.INTERIOR] === 0;
      }
      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IntersectionMatrix;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Cloneable];
    }
  }], [{
    key: "matches",
    value: function matches() {
      if (Number.isInteger(arguments[0]) && typeof arguments[1] === 'string') {
        var actualDimensionValue = arguments[0];
        var requiredDimensionSymbol = arguments[1];
        if (requiredDimensionSymbol === Dimension.SYM_DONTCARE) {
          return true;
        }
        if (requiredDimensionSymbol === Dimension.SYM_TRUE && (actualDimensionValue >= 0 || actualDimensionValue === Dimension.TRUE)) {
          return true;
        }
        if (requiredDimensionSymbol === Dimension.SYM_FALSE && actualDimensionValue === Dimension.FALSE) {
          return true;
        }
        if (requiredDimensionSymbol === Dimension.SYM_P && actualDimensionValue === Dimension.P) {
          return true;
        }
        if (requiredDimensionSymbol === Dimension.SYM_L && actualDimensionValue === Dimension.L) {
          return true;
        }
        if (requiredDimensionSymbol === Dimension.SYM_A && actualDimensionValue === Dimension.A) {
          return true;
        }
        return false;
      } else if (typeof arguments[0] === 'string' && typeof arguments[1] === 'string') {
        var actualDimensionSymbols = arguments[0];
        var requiredDimensionSymbols = arguments[1];
        var m = new IntersectionMatrix(actualDimensionSymbols);
        return m.matches(requiredDimensionSymbols);
      }
    }
  }, {
    key: "isTrue",
    value: function isTrue(actualDimensionValue) {
      if (actualDimensionValue >= 0 || actualDimensionValue === Dimension.TRUE) {
        return true;
      }
      return false;
    }
  }]);
}();
export { IntersectionMatrix as default };
IntersectionMatrix.constructor_ = function () {
  this._matrix = null;
  if (arguments.length === 0) {
    this._matrix = Array(3).fill().map(function () {
      return Array(3);
    });
    this.setAll(Dimension.FALSE);
  } else if (arguments.length === 1) {
    if (typeof arguments[0] === 'string') {
      var elements = arguments[0];
      IntersectionMatrix.constructor_.call(this);
      this.set(elements);
    } else if (arguments[0] instanceof IntersectionMatrix) {
      var other = arguments[0];
      IntersectionMatrix.constructor_.call(this);
      this._matrix[Location.INTERIOR][Location.INTERIOR] = other._matrix[Location.INTERIOR][Location.INTERIOR];
      this._matrix[Location.INTERIOR][Location.BOUNDARY] = other._matrix[Location.INTERIOR][Location.BOUNDARY];
      this._matrix[Location.INTERIOR][Location.EXTERIOR] = other._matrix[Location.INTERIOR][Location.EXTERIOR];
      this._matrix[Location.BOUNDARY][Location.INTERIOR] = other._matrix[Location.BOUNDARY][Location.INTERIOR];
      this._matrix[Location.BOUNDARY][Location.BOUNDARY] = other._matrix[Location.BOUNDARY][Location.BOUNDARY];
      this._matrix[Location.BOUNDARY][Location.EXTERIOR] = other._matrix[Location.BOUNDARY][Location.EXTERIOR];
      this._matrix[Location.EXTERIOR][Location.INTERIOR] = other._matrix[Location.EXTERIOR][Location.INTERIOR];
      this._matrix[Location.EXTERIOR][Location.BOUNDARY] = other._matrix[Location.EXTERIOR][Location.BOUNDARY];
      this._matrix[Location.EXTERIOR][Location.EXTERIOR] = other._matrix[Location.EXTERIOR][Location.EXTERIOR];
    }
  }
};